<template>
  <div v-if="!loading">
    <dictation-item-desktop v-if="screenType === 'desktop'" :item="item" :online-class="onlineClass"
                         :dictation="dictation" :answers="answers"></dictation-item-desktop>
    <dictation-item-mobile v-else :item="item" :online-class="onlineClass"
                           :dictation="dictation" :answers="answers"></dictation-item-mobile>
  </div>
</template>

<script>
import DictationItemDesktop from "@/components/Pages/Desktop/Dashboard/Lessons/DictationItemDesktop";
import DictationItemMobile from "@/components/Pages/Mobile/Dashboard/Lessons/DictationItemMobile";

export default {
  name: "DictationItemMain",
  components: {DictationItemMobile, DictationItemDesktop},
  data() {
    return {
      item: null,
      loading: true,
      classId: null,
      dictation: null,
      onlineClass: null,
      answers: null,
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop',
    }
  },
  methods: {
    getDictation() {
      window.axios.get('student/courses/lessons/dictation/full/' + this.$route.params.dictationId + '/' +this.$route.params.itemId+'/'+ this.$route.params.classId).then((res) => {
        this.item = res.data.data.item
        this.dictation = res.data.data.dictation
        this.answers = res.data.data.answers
        this.onlineClass = res.data.data.online_class
        this.loading = false
      })
    }
  },
  mounted() {
    this.classId = this.$route.params.classId
    this.getDictation()
  }
}
</script>

<style scoped>

</style>